<template>
<div v-if="!isPageLoading">
    <div v-if="hasAdminAccess && (user != null || currentuser != null)">
        <v-card>
            <v-card-title v-show="!isLoggedInUserActive">
                <label style="color: red">{{ $t("msguserisnotactive") }}</label>
            </v-card-title>
            <v-data-table :headers="headers" :items="feedbacks" :search="search" v-show="isLoggedInUserActive" :footer-props="{
            itemsPerPageOptions: tableItemsPerPage,
            itemsPerPageText: rowsperpage,
          }" :options="options">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <h3>{{ $t("feedback") }}</h3>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:no-data>
                    <v-alert border="right" colored-border type="error" elevation="2">
                        {{ $t("norecordsfound") }}
                    </v-alert>
                </template>
            </v-data-table>
        </v-card>
    </div>
    <div v-else-if="user != null || currentuser != null">
        <v-alert outlined type="warning" prominent border="left">
            {{ $t("accessdenied") }}
        </v-alert>
    </div>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            feedbacks: [],
            useraccess: [],
            currentuser: [],
            isPageLoading: true,
            user: null,
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
        };
    },
    mounted() {
        this.getFeedbacksFromAPI();
    },
    methods: {
        getFeedbacksFromAPI() {
            var self = this;
            self.isPageLoading = true;
            
            const link = window.apiurl + "/MppiChFeedbacks";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.user = self.$store.state.userDetails;
                    self.feedbacks = response.data;
                    if (self.user != null) {
                        const link2 =
                            window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                        axios
                            .get(link2, {
                                withCredentials: true,
                                headers: self.requestHeaders
                            })
                            .then((response) => {
                                self.useraccess = response.data;
                                i18n.locale = self.useraccess[0].language;
                                if (self.useraccess[0].rowsPerPage != null) {
                                    var rowsPrPg =
                                        self.useraccess[0].rowsPerPage == "All" ?
                                        -1 :
                                        parseInt(self.useraccess[0].rowsPerPage);
                                    self.options = {
                                        itemsPerPage: rowsPrPg,
                                    };
                                } else {
                                    self.options = {
                                        itemsPerPage: 25,
                                    };
                                }
                                self.isPageLoading = false;
                            })
                            .catch((error) => console.log(error));
                    } else {
                        self.getUser();
                    }
                })
                .catch((error) => console.log(error));
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                            i18n.locale = self.useraccess[0].language;
                            self.isPageLoading = false;
                        })
                        .catch((error) => console.log(error));
                })
                .then(() => self.$store.commit("globalUser", self.currentuser))
                .catch((error) => console.log(error));
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        // user() {
        //   return this.$store.state.userDetails;
        // },
        hasAdminAccess() {
            var adminaccess = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.plant == "Global" || x.company == "LYB"
            );
            if (filterUser != null && filterUser.length > 0) {
                adminaccess = true;
            }
            return adminaccess;
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        headers() {
            return [{
                    text: this.$t("reportedby"),
                    align: "start",
                    value: "reportedBy",
                },
                { text: this.$t("comments"), value: "comments" },
                { text: this.$t("date"), value: "createdDate" },
            ];
        },
    },
    watch: {
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/Feedback.vue